import { render, staticRenderFns } from "./SidenavRouterLink.vue?vue&type=template&id=43c94fb0"
import script from "./SidenavRouterLink.vue?vue&type=script&lang=js"
export * from "./SidenavRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports